export const COLOR_LIST = ['beige', 'purple', 'blue', 'green'];

export const RELATION_LIST = ['지인', '친구', '동료', '가족'];

export const FONT_LIST = [
  'Noto Sans',
  'Pretendard',
  '나눔명조',
  '나눔손글씨 손편지체',
];
